export function KeyboardPadding({maxHeight: _}: {maxHeight?: number}) {
  return null
}
